webpackJsonp([219286714057974],{

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _CheckboxGroup = __webpack_require__(17);
	
	var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Datetime = __webpack_require__(18);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Formboss = function (_Component) {
	  _inherits(Formboss, _Component);
	
	  function Formboss(props) {
	    _classCallCheck(this, Formboss);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  Formboss.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "600px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading3", gutterBottom: true },
	            "Fantastic!"
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading5", gutterTop: true },
	            "We\u2019ll reach out to you asap via email or telephone.",
	            _react2.default.createElement("br", null),
	            "You can also speak to a member of our sales team immediately by calling",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "tel:18339781196", className: classes.link },
	              "833.978.1196"
	            ),
	            "."
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          mls_number: "",
	          form: "boss_product",
	          list: 107390,
	          meetingdate: "",
	          meetingtime: ""
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            mls_number: Yup.string()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          //if (values.meetingdate != undefined) {
	          var meeting_request = "";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	          });
	          var body = _extends({}, values, {
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            demo_request_date: meeting_request
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "broker");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxWidth: "600px",
	                  marginLeft: "auto",
	                  marginRight: "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "firstname",
	                  name: "firstname",
	                  placeholder: "First Name",
	                  component: _Input2.default,
	                  className: classes.field
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "lastname",
	                  name: "lastname",
	                  placeholder: "Last Name",
	                  component: _Input2.default,
	                  className: classes.field
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "email",
	                name: "email",
	                placeholder: "Email",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "phone",
	                name: "phone",
	                placeholder: "Phone",
	                component: _Input2.default,
	                className: classes.field,
	                type: "tel"
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "company",
	                name: "company",
	                placeholder: "Affiliation (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "mls_number",
	                name: "mls_number",
	                placeholder: "MLS # (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "submit",
	                  className: classes.signUpBtn,
	                  disabled: isSubmitting,
	                  style: { width: "70%" }
	                },
	                "Please Contact Me"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "11px", lineHeight: "16px" } },
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means. Existing subscribers seeking support, please visit the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://support.tryelevate.com/s/ " },
	                "Elevate Help Center"
	              ),
	              "."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return Formboss;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "800px",
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    headingSmall: {
	      fontSize: "20px",
	      textTransform: "uppercase",
	      fontWeight: "600",
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingLarge: {
	      fontSize: "40px",
	      textTransform: "uppercase",
	      fontWeight: "700",
	      color: "#55c3ba",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingText: {
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "1.4em"
	    },
	    checkfield: {
	      width: "20px",
	      height: "20px",
	      position: "relative",
	      top: "4px",
	      marginLeft: "10px"
	    },
	    signUpBtn: {
	      width: "100%",
	      fontSize: "20px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: theme.colors.secondary,
	      borderRadius: "6px",
	      padding: "12px",
	      marginTop: "30px",
	      marginBottom: "30px",
	      textDecoration: "none"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    }
	  };
	})(Formboss);
	module.exports = exports["default"];

/***/ }),

/***/ 3046:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss1.f7313834.png";

/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss10.fa211cee.png";

/***/ }),

/***/ 3047:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss2.b21306f5.png";

/***/ }),

/***/ 3048:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss3.e571cce7.png";

/***/ }),

/***/ 3049:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss4.6d6fdbbf.png";

/***/ }),

/***/ 3050:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss5.aabd25f7.png";

/***/ }),

/***/ 3051:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss6.ef47c5b4.png";

/***/ }),

/***/ 3052:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss7.2146257a.png";

/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss8.48ef542b.png";

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/boss9.9e42c650.png";

/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bosslogo.692cddea.png";

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bossstar.84bacf33.png";

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/checklist_cover.3e58aa4e.jpg";

/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _BgSectionExternal = __webpack_require__(33);
	
	var _BgSectionExternal2 = _interopRequireDefault(_BgSectionExternal);
	
	var _Formboss = __webpack_require__(1569);
	
	var _Formboss2 = _interopRequireDefault(_Formboss);
	
	var _Formchecklist = __webpack_require__(1171);
	
	var _Formchecklist2 = _interopRequireDefault(_Formchecklist);
	
	var _bossbg = __webpack_require__(1148);
	
	var _bossbg2 = _interopRequireDefault(_bossbg);
	
	var _boss = __webpack_require__(3046);
	
	var _boss2 = _interopRequireDefault(_boss);
	
	var _boss3 = __webpack_require__(3047);
	
	var _boss4 = _interopRequireDefault(_boss3);
	
	var _boss5 = __webpack_require__(3048);
	
	var _boss6 = _interopRequireDefault(_boss5);
	
	var _boss7 = __webpack_require__(3049);
	
	var _boss8 = _interopRequireDefault(_boss7);
	
	var _boss9 = __webpack_require__(3050);
	
	var _boss10 = _interopRequireDefault(_boss9);
	
	var _boss11 = __webpack_require__(3051);
	
	var _boss12 = _interopRequireDefault(_boss11);
	
	var _boss13 = __webpack_require__(3052);
	
	var _boss14 = _interopRequireDefault(_boss13);
	
	var _boss15 = __webpack_require__(1146);
	
	var _boss16 = _interopRequireDefault(_boss15);
	
	var _boss17 = __webpack_require__(1147);
	
	var _boss18 = _interopRequireDefault(_boss17);
	
	var _boss19 = __webpack_require__(1145);
	
	var _boss20 = _interopRequireDefault(_boss19);
	
	var _fadebg = __webpack_require__(42);
	
	var _fadebg2 = _interopRequireDefault(_fadebg);
	
	var _bosslogo = __webpack_require__(1149);
	
	var _bosslogo2 = _interopRequireDefault(_bosslogo);
	
	var _bossstar = __webpack_require__(1150);
	
	var _bossstar2 = _interopRequireDefault(_bossstar);
	
	var _quote = __webpack_require__(51);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _checklist_cover = __webpack_require__(1151);
	
	var _checklist_cover2 = _interopRequireDefault(_checklist_cover);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Boss = function Boss(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Elevate Boss - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Elevate Boss - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "Boss", customTitle: true }),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _bossbg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerTop" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { paddingRight: "35px", paddingLeft: "35px", paddingTop: "65px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.centerHeading },
	            _react2.default.createElement("img", { src: _bosslogo2.default, width: "100%", style: { paddingBottom: "18px", paddingTop: "20px", maxWidth: "220px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading, style: { color: "#ffffff" } },
	              "The Power of ONE"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext, style: { color: "#f7f7f7" } },
	              "One vendor.  One point of contact.  One solution.  For your entire office.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.subtext2, style: { color: "#FCBA1E" } },
	                "Ask us how we drive HIGH agent adoption rates!"
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { maxWidth: "800px", marginLeft: "auto", marginRight: "auto", paddingTop: "40px" } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { textAlign: "center" }, className: classes.videoEmbed },
	                  _react2.default.createElement("iframe", { className: classes.videoContainer, src: "https://www.youtube.com/embed/F1jXTGc2Xng?autoplay=1&rel=0",
	                    frameborder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowfullscreen: true })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { paddingBottom: "50px" } },
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center", paddingBottom: "10px" } },
	            _react2.default.createElement(
	              "a",
	              { href: "#demo", className: classes.buttonLink },
	              "Request Demo"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "58px" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", paddingRight: "35px", paddingLeft: "35px", paddingBottom: "25px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.Heading2 },
	            "Key Highlights"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.subtext },
	            "The 1st true productivity platform in real estate offers a more efficient, cost-effective way",
	            _react2.default.createElement("br", null),
	            "to increase production & help your agents sell more homes...faster."
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _fadebg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerBottom", paddingBottom: "65px" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Brokerage",
	              _react2.default.createElement("br", null),
	              "recruiting module"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss4.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Brokerage-level",
	              _react2.default.createElement("br", null),
	              "advanced dashboard"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss6.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Brokerage, office",
	              _react2.default.createElement("br", null),
	              "& agent KPIs"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss8.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Lead capture/response",
	              _react2.default.createElement("br", null),
	              "routing & tracking"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss10.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Lead generation,",
	              _react2.default.createElement("br", null),
	              "parsing & scrubbing"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss12.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Customer activity",
	              _react2.default.createElement("br", null),
	              "workflows & task coaching"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss14.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Document",
	              _react2.default.createElement("br", null),
	              "management"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss16.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Agent-protected",
	              _react2.default.createElement("br", null),
	              "databases"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss18.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "CMA Wizard"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column4, style: { textAlign: "center", paddingTop: "45px" } },
	            _react2.default.createElement("img", { src: _boss20.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext2 },
	              "Team capable"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement("a", { id: "demo" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundColor: "#ffffff", paddingBottom: "60px", textAlign: "center", paddingRight: "30px", paddingLeft: "30px" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "h1",
	          { className: classes.Heading2, style: { paddingTop: "70px" } },
	          "Tour the BOSS"
	        ),
	        _react2.default.createElement(
	          "h2",
	          { className: classes.subtext, style: { paddingBottom: "40px" } },
	          "Request your personal consultation with our broker",
	          _react2.default.createElement("br", null),
	          "development team using the form below, or call 833-303-1040 to speak to us today."
	        ),
	        _react2.default.createElement(_Formboss2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "50px", paddingBottom: "50px", backgroundColor: "#f7f7f7" } },
	      _react2.default.createElement(
	        "div",
	        { style: { textAlign: "center", paddingRight: "35px", paddingLeft: "35px", paddingBottom: "25px" } },
	        _react2.default.createElement(
	          "div",
	          { className: classes.Heading2 },
	          "Happy Customers"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.subtext },
	          "What the world needs now is love, love, love."
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.flexContainer },
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CElevate BOSS\xAE has helped",
	              _react2.default.createElement("br", null),
	              "my independent office",
	              _react2.default.createElement("br", null),
	              "compete against the",
	              _react2.default.createElement("br", null),
	              "big box brands.\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Joe J."
	              ),
	              "Nashville, TN"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201COur agents love",
	              _react2.default.createElement("br", null),
	              "all of the technology",
	              _react2.default.createElement("br", null),
	              "and marketing tools we now",
	              _react2.default.createElement("br", null),
	              "offer with Elevate.\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Jenn & Mark N."
	              ),
	              "Los Angeles, CA"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem2, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _quote2.default, width: "80", style: { paddingBottom: "15px" } }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "\u201CI went from 13 vendors down",
	              _react2.default.createElement("br", null),
	              "to 3 with Elevate. Not only",
	              _react2.default.createElement("br", null),
	              "did I save tons of money, but my stress",
	              _react2.default.createElement("br", null),
	              "level seriously dropped!\u201D",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.Heading3 },
	                "Jacob M."
	              ),
	              "Worcester, MA"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingTop: "50px", paddingBottom: "50px" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", paddingRight: "25px", paddingLeft: "25px", paddingBottom: "25px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.Heading2 },
	            "Brokerage Technology Checklist",
	            _react2.default.createElement("br", null),
	            "FREE DOWNLOAD"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.subtext },
	            "Download your comprehensive guide to selecting the right technology partner for your brokerage. Includes the top 4 questions to ask tech companies to separate potential partners from vendors, and a checklist of features & functionality every brokerage must have!"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.flexContainer },
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement(_Formchecklist2.default, null)
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.flexItem, style: { padding: "30px", textAlign: "center" } },
	            _react2.default.createElement("img", { src: _checklist_cover2.default, width: "100%", style: { paddingBottom: "15px" } })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _flexContainer, _flexItem, _flexItem2, _flexItem3;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      margin: "auto"
	    },
	
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "top"
	    },
	
	    heading: {
	      fontSize: "33px",
	      fontWeight: "700",
	      lineHeight: "40px",
	      letterSpacing: ".14px",
	      color: "#52B1AD",
	      marginBottom: "12px"
	    },
	
	    subtext: {
	      fontSize: "16px",
	      fontWeight: "300",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    subtext2: {
	      fontSize: "16px",
	      fontWeight: "700",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    column2: {
	      width: "530px",
	      maxWidth: "100%",
	      paddingRight: "20px",
	      paddingLeft: "20px",
	      verticalAlign: "top"
	    },
	
	    column3: {
	      width: "350px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	
	    column4: {
	      width: "260px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	
	    bold: {
	      fontWeight: "700"
	    },
	
	    centerHeading: {
	      alignItems: "center",
	      width: "100%",
	      textAlign: "center"
	    },
	
	    Heading2: {
	      fontSize: "28px",
	      paddingBottom: "20px",
	      fontWeight: "700",
	      lineHeight: "40px",
	      color: "#52B1AD",
	      letterSpacing: ".14px"
	    },
	
	    Heading3: {
	      fontSize: "20px",
	      paddingBottom: "5px",
	      fontWeight: "700",
	      lineHeight: "26px",
	      color: "#52B1AD",
	      letterSpacing: ".14px"
	    },
	
	    landingHeaderStyle: {
	      textAlign: "center"
	    },
	
	    buttonLink: {
	      minWidth: "250px",
	      maxWidth: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      display: "block",
	      letterSpacing: ".25px",
	      backgroundColor: "#52B1AD",
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "16px",
	      borderRadius: "4px",
	      margin: "16px auto",
	      marginBottom: "10px"
	    },
	
	    flexContainer: (_flexContainer = {
	      padding: "0",
	      margin: '0',
	
	      display: "-webkit-box"
	    }, _flexContainer["display"] = "-moz-box", _flexContainer["display"] = "-ms-flexbox", _flexContainer["display"] = "-webkit-flex", _flexContainer["display"] = "flex", _flexContainer.flexWrap = "wrap", _flexContainer),
	    flexItem: (_flexItem = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem[theme.breakpoints[900]] = {
	      maxWidth: "50%",
	      width: "50%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem),
	
	    flexItem2: (_flexItem2 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem2[theme.breakpoints[900]] = {
	      maxWidth: "33%",
	      width: "33%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem2),
	
	    flexItem3: (_flexItem3 = {
	      maxWidth: "100%",
	      width: "100%",
	      paddingRight: "0px",
	      paddingBottom: "25px"
	
	    }, _flexItem3[theme.breakpoints[900]] = {
	      maxWidth: "40%",
	      width: "40%",
	      paddingRight: "20px",
	      paddingBottom: "0px"
	    }, _flexItem3),
	    videoEmbed: {
	      position: "relative",
	      paddingBottom: "56.25%",
	      paddingTop: "30px",
	      height: "0",
	      overflow: "hidden"
	
	    },
	    videoContainer: {
	      position: "absolute",
	      top: "0",
	      left: "0",
	      width: "100%",
	      height: "100%"
	
	    }
	  };
	})(Boss);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-boss-js-eca7a7fb74f22b5eace4.js